module.exports = __webpack_public_path__ + "static/media/balloons-example.f2b4e7d2.gif";